<template>
    <section id="register" class="bg-cover bg-overlay-black-6" :style="'height:' + windowHeight + 'px!important'">
        <div class="container">
            <div class="row">
                <div class="col-sm-6 col-md-7 xs-text-center">
                    <span class="display-block font-family-alt letter-spacing-1 opacity-9 margin-7 no-margin-bottom no-margin-rl text-white text-medium text-uppercase">Tilmeld dig allerede nu!</span>
                    <h2 class="display-block font-family-alt font-weight-700 letter-spacing-2 margin-5 no-margin-bottom no-margin-rl text-white xs-title-medium title-extra-large-3 text-uppercase vw-bold">Vil du med?<br>Tilmeld dig her</h2>
                    <span class="bg-base-color display-inline-block margin-5-5 no-margin-rl separator-line-medium-thick-long"></span>
                </div>
                <div class="col-sm-6 col-md-5">
                    <div class="form-wrapper border-round padding-8">
                        <!-- Begin MailChimp Signup Form -->

                        <!--End mc_embed_signup-->
                        <div id="mc_embed_signup" v-if="!disabled">
                            <form v-if="!submitted" @submit.prevent="register()" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
                                <div class="form-val-group">
                                    <input type="text" v-model="body.CNAME" placeholder="Virksomhed" v-validate="'required'">
                                </div>
                                <div class="form-val-group">
                                    <input type="text" v-model="body.FNAME" placeholder="Fulde navn" v-validate="'required'">
                                </div>
                                <div class="form-val-group">
                                    <input type="email" v-model="body.EMAIL" placeholder="E-mail adresse" v-validate="'required|email'">
                                </div>
                                <div class="form-val-group">
                                    <input type="text" v-model="body.PHONE" placeholder="Telefon" v-validate="'required|numeric'">
                                </div>
                                <div class="newsletter-wrapper">
                                    <span>
                                        <a rel="noopener"
                                           target="_blank"
                                           href="https://www.volkswagen-erhvervsbiler.dk/app/web/erhverv/tilmeld-nyhedsbrev/"
                                        >
                                            Tilmeld dig vores nyhedsbrev &rarr;
                                        </a>
                                    </span>
                                </div>
                                <button type="submit"
                                        name="subscribe"
                                        id="mc-embedded-subscribe"
                                        class="form-submit btn btn-base-color btn-medium button"
                                        :disabled="!isValidated"
                                >
                                    <span v-if="!loading">Tilmeld</span>
                                    <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                                </button>
                            </form>
                            <div v-else class="submit-success">
                                <h3>
                                    Tak for din tilmelding!
                                </h3>
                                <p>
                                    Du vil modtage nærmere info via e-mail snarest.
                                </p>
                            </div>
                        </div>

                        <div v-else style="color:#fff;">
                            Dato for næste arrangement kommer snart, hvorefter du kan tilmelde dig her på siden.
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import * as registerService from '../../services/register/registerService'
import axios from 'axios'

export default {
    props: {
        eventId: {
            required: true,
            type: String
        },
        eventToken: {
            required: true,
            type: String
        },
        disabled: {
            required: false,
            type: Boolean
        },
        name: {
            required: true,
            type: String
        }
    },
    data () {
        return {
            windowHeight: 400,
            submitted: false,
            loading: false,
            body: {
                FNAME: '',
                CNAME: '',
                EMAIL: '',
                PHONE: '',
                u: this.eventId,
                id: this.eventToken,
                c: 'JSON.stringify'
            }
        }
    },
    created () {
        this.checkHeight()
    },
    computed: {
        isValidated () {
            const body = this.body
            if (this.errors.items.length > 0) {
                return false
            }
            if (body.FNAME === '') {
                return false
            }
            if (body.CNAME === '') {
                return false
            }
            if (body.EMAIL === '') {
                return false
            }
            if (body.PHONE === '') {
                return false
            }
            return true
        }
    },
    methods: {
        checkHeight () {
            this.windowHeight = window.innerHeight
        },
        register () {
            this.body['b_' + this.eventId + '_' + this.eventToken] = ''
            registerService.submit(this.body)
            this.submitted = true
            window.fbq('trackCustom', 'Succesfuld tilmelding')
            window.fbq('track', 'CompleteRegistration', {content_name: this.name})
            axios.post('https://hooks.slack.com/services/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', {
                username: 'VW ' + this.name,
                text: 'En bruger har lige tilmeldt sig næste netværksmøde!'
                },
                {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
        },
        newsletterInfo () {
            this.$swal('Fremtidige arrangementer', '3 gange årligt sender vi informationer ud, hvor du kan læse om nye spændende arrangementer.')
        }
    }
}
</script>
<style scoped>
    .form-val-group{
        position: relative;
    }
    button.form-submit{
        border: 2px solid rgba(0,0,0,.13);
        min-width: 117px;
    }
    .submit-success{
        color: #fff;
    }
    .submit-success p{
        margin: 0;
    }
    #register{
        min-height: 800px;
    }
    .newsletter-wrapper{
        color: #fff;
        margin-bottom: 20px;
    }
    .newsletter-wrapper a{
        color: #fff;
    }
    .newsletter-wrapper a:hover{
        opacity: 0.9;
    }
    .newsletter-toggle{
        color: #fff;
        padding: 0px 3px;
        text-align: center;
        display: inline-block;
        margin-bottom: 20px;
        border: 2px solid rgba(0, 0, 0, 0.13);
    }
    .newsletter-toggle:focus{
        outline: 0;
    }
    .newsletter-toggle:hover{
        cursor: pointer;
    }
    .newsletter-toggle.true{
        background-color: #5cb85c;
    }
    .newsletter-toggle.false{
        background-color: #fff;
    }
    .newsletter-wrapper u:hover{
        cursor: pointer;
    }
    input[aria-invalid=true]{
        border: 2px solid #F44336;
    }
    input:focus, input:visited{
        border-width: 2px;
    }
    .btn.btn-base-color:hover{
        opacity: .65;
    }
</style>



// WEBPACK FOOTER //
// registration.vue?36a3cb99